import { HomePage } from './HomePage'
import { PageBodyProps } from './types'

const PageBody = (props: PageBodyProps) => {
  return (
    <HomePage
      banner={props.homepageBanner}
      footerBanner={props?.homepageFooterBanner}
      trendingArticles={props.trendingArticles}
      categories={props.categories}
      healthTools={props.healthTools}
      healthyLivingArticles={props.healthyLivingArticles}
      drugArticles={props.drugArticles}
      pregnancyArticles={props.pregnancyArticles}
      expertsArticles={props.expertsArticles}
      medicalReviewed={props.medicalReviewed}
      spotlights={props.spotlights}
      expertHeading={props.expertHeading}
      homeCommunityData={props?.homeCommunityData}
      homeCommunities={props?.homeCommunities}
      homeVideos={props.homeVideos}
      isMobileSsr={props.isMobileSsr}
      newsEventsTitle={props.newsEventsTitle}
      homeHealthTool={props.homeHealthTool}
      homeHasMostReadPosts={props.homeHasMostReadPosts}
      homeCategories={props.homeCategories}
    />
  )
}

export { PageBody }
